var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ1TopLeftArrowC(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.64 26.93H29.79L53 50.14 50.14 53 26.93 29.79v17.85L23 51.57V23h28.57l-3.93 3.93z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J1_Top-left_arrow_C.8a44a82c.svg";
export { SvgJ1TopLeftArrowC as ReactComponent };